(function(){
  document.documentElement.classList.add('atelier');
  var drawer = document.getElementById('cartDrawer');
  if(!drawer) return;
  function money(c){ return (c/100).toLocaleString('de-DE',{minimumFractionDigits:2}).replace(/,00$/,'') + ' €'; }
  function clean(t){ return (t||'').replace('Fotografie-Print – ','').replace('Fotografie-Print - ',''); }
  // landscape prints: variant titles are stored portrait (small×large); show width first in the drawer to match the PDP.
  // Orientation isn't in cart.js (variant images are square), so look it up once per product from its artwork aspect.
  var orient={}, lastCart=null;
  function flip(t){ var m=String(t).match(/^\s*(\d+(?:[.,]\d+)?)\s*[×x*]\s*(\d+(?:[.,]\d+)?)(.*)$/i); return m?(m[2]+'×'+m[1]+m[3]):t; }
  function ensureOrient(items){
    var todo=[];
    items.forEach(function(i){ if(i.handle && orient[i.handle]===undefined && todo.indexOf(i.handle)<0) todo.push(i.handle); });
    if(!todo.length) return;
    Promise.all(todo.map(function(h){
      return fetch('/products/'+h+'.js',{headers:{'Accept':'application/json'}}).then(function(r){return r.json();})
        .then(function(p){ orient[h]=!!(p.media&&p.media[0]&&p.media[0].aspect_ratio>1); })
        .catch(function(){ orient[h]=false; });
    })).then(function(){ if(lastCart) render(lastCart); });
  }
  function render(cart){
    lastCart=cart;
    var body=document.getElementById('cdBody'), foot=document.getElementById('cdFoot');
    if(!cart.items || !cart.items.length){ body.innerHTML='<p class="cd__empty">Dein Warenkorb ist leer.</p>'; foot.innerHTML=''; return; }
    body.innerHTML = cart.items.map(function(i){
      var vt = orient[i.handle] ? flip(i.variant_title) : i.variant_title;
      var opt = (i.variant_title && i.variant_title.indexOf('Default')<0) ? '<div class="cd-it__opt">'+vt+'</div>' : '';
      return '<div class="cd-it"><img src="'+i.image+'&width=160" alt=""><div class="cd-it__m"><div class="cd-it__t">'+clean(i.product_title)+'</div>'+opt
        +'<div class="cd-it__row"><div class="cd-it__qty">'
          +'<button type="button" class="cd-it__q" data-key="'+i.key+'" data-q="'+(i.quantity-1)+'" aria-label="Weniger">−</button>'
          +'<span class="cd-it__qn">'+i.quantity+'</span>'
          +'<button type="button" class="cd-it__q" data-key="'+i.key+'" data-q="'+(i.quantity+1)+'" aria-label="Mehr">+</button>'
        +'</div><div class="cd-it__p">'+money(i.final_line_price)+'</div></div>'
        +'</div><button class="cd-it__rm" data-key="'+i.key+'" aria-label="Entfernen"><i class="ti ti-x"></i></button></div>';
    }).join('');
    foot.innerHTML = '<div class="cd__sub"><span class="kick">Zwischensumme</span><span>'+money(cart.total_price)+'</span></div>'
      +'<p class="cd__tax">inkl. MwSt · kostenloser Versand</p>'
      +'<a href="/checkout" class="btn solid block">Zur Kasse</a><a href="/cart" class="cd__view">Warenkorb ansehen</a>';
    ensureOrient(cart.items);
  }
  function load(){ return fetch('/cart.js',{headers:{'Accept':'application/json'}}).then(function(r){return r.json();}).then(render); }
  function open(){ load(); drawer.classList.add('open'); drawer.setAttribute('aria-hidden','false'); document.body.style.overflow='hidden'; }
  function close(){ drawer.classList.remove('open'); drawer.setAttribute('aria-hidden','true'); document.body.style.overflow=''; }
  document.querySelectorAll('a[href$="/cart"]').forEach(function(a){ a.addEventListener('click',function(e){e.preventDefault();open();}); });
  function change(key, qty){
    var b=document.getElementById('cdBody'); if(b) b.classList.add('is-updating');
    fetch('/cart/change.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({id:key,quantity:qty})})
      .then(function(r){return r.json();}).then(render).catch(function(){})
      .then(function(){ var b2=document.getElementById('cdBody'); if(b2) b2.classList.remove('is-updating'); });
  }
  drawer.addEventListener('click',function(e){
    if(e.target.closest('[data-cd-close]')){ close(); return; }
    var q=e.target.closest('.cd-it__q');
    if(q){ if(!document.getElementById('cdBody').classList.contains('is-updating')) change(q.dataset.key, +q.dataset.q); return; }
    var rm=e.target.closest('.cd-it__rm');
    if(rm){ change(rm.dataset.key, 0); }
  });
  document.addEventListener('submit',function(e){
    var f=e.target;
    if(f.matches && f.matches('form[action*="/cart/add"]')){
      e.preventDefault();
      var btn=f.querySelector('[name="add"], button[type="submit"]');
      if(btn) btn.classList.add('is-loading');
      fetch('/cart/add.js',{method:'POST',headers:{'Accept':'application/json'},body:new FormData(f)})
        .then(function(r){ return r.json(); })
        .then(function(){ open(); })
        .catch(function(){})
        .then(function(){ if(btn) btn.classList.remove('is-loading'); });
    }
  });
  document.addEventListener('keydown',function(e){ if(e.key==='Escape') close(); });
})();

/* full-bleed hero: size to viewport minus the sticky header */
(function(){
  function setH(){var h=document.getElementById('shopify-section-header'); if(h) document.documentElement.style.setProperty('--header-h', h.offsetHeight + 'px');}
  setH();
  window.addEventListener('resize', setH);
  window.addEventListener('load', setH);
  var hd=document.getElementById('shopify-section-header');
  if(window.ResizeObserver && hd) new ResizeObserver(setH).observe(hd);
})();

/* hero slideshow — dots + arrows + auto-advance (manual interaction resets timer) */
(function(){
  var hero=document.querySelector('.hero--slides'); if(!hero) return;
  var slides=[].slice.call(hero.querySelectorAll('.hslide'));
  var dots=[].slice.call(hero.querySelectorAll('.hdot'));
  var cur=document.getElementById('hCur');
  if(!slides.length) return;
  var i=0, timer, DUR=6000;
  function pad(n){ return (n+1<10?'0':'')+(n+1); }
  function show(n){
    n=(n+slides.length)%slides.length;
    slides[i].classList.remove('is-active'); if(dots[i]) dots[i].classList.remove('is-active');
    i=n;
    slides[i].classList.add('is-active'); if(dots[i]) dots[i].classList.add('is-active');
    if(cur) cur.textContent=pad(i);
  }
  function start(){ if(slides.length<2) return; clearInterval(timer); timer=setInterval(function(){ show(i+1); }, DUR); }
  show(0); start();
  dots.forEach(function(d){ d.addEventListener('click', function(){ show(+d.dataset.i); start(); }); });
  hero.querySelectorAll('.harrow').forEach(function(a){ a.addEventListener('click', function(){ show(i + (+a.dataset.dir)); start(); }); });
})();

/* collection: AJAX filter / sort / pagination — swap grid in place, keep scroll, update URL */
(function(){
  var wrap=document.querySelector('.col-grid-wrap'); if(!wrap) return;
  window.__atelierAjaxCol=true; // tells the sort <select> to skip its no-JS form.submit fallback
  var ctrl;
  function load(url, opts){
    opts=opts||{};
    if(ctrl) ctrl.abort();
    ctrl=new AbortController();
    wrap.classList.add('is-loading');
    fetch(url,{signal:ctrl.signal})
      .then(function(r){ return r.text(); })
      .then(function(html){
        var doc=new DOMParser().parseFromString(html,'text/html');
        var fresh=doc.querySelector('.col-grid-wrap');
        if(fresh){ wrap.innerHTML=fresh.innerHTML; }
        if(opts.push!==false) history.pushState({col:1},'',url);
        if(opts.scrollTop){
          var tb=wrap.querySelector('.col-toolbar');
          if(tb) window.scrollTo({top:tb.getBoundingClientRect().top+window.scrollY-120, behavior:'smooth'});
        }
      })
      .catch(function(e){ if(e.name!=='AbortError') window.location.assign(url); })
      .then(function(){ wrap.classList.remove('is-loading'); });
  }
  wrap.addEventListener('click', function(e){
    var a=e.target.closest('a'); if(!a) return;
    if(a.closest('.col-filters')){ e.preventDefault(); load(a.href,{}); }
    else if(a.closest('.col-pagination')){ e.preventDefault(); load(a.href,{scrollTop:true}); }
  });
  wrap.addEventListener('change', function(e){
    if(e.target && e.target.name==='sort_by'){
      var f=e.target.closest('form'); if(!f) return;
      var p=new URLSearchParams(new FormData(f)).toString();
      load(location.pathname+(p?'?'+p:''),{});
    }
  });
  window.addEventListener('popstate', function(){ load(location.href,{push:false}); });
})();

/* Native write-review modal (no third-party widget) */
(function(){
  var modal = document.getElementById('revModal'); if(!modal) return;
  var form = document.getElementById('revForm'), done = document.getElementById('revDone');
  var ratingInput = document.getElementById('revRating');
  function openModal(){ modal.classList.add('open'); modal.setAttribute('aria-hidden','false'); document.body.style.overflow='hidden'; }
  function closeModal(){ modal.classList.remove('open'); modal.setAttribute('aria-hidden','true'); document.body.style.overflow=''; }

  document.addEventListener('click', function(e){
    if(e.target.closest('[data-rev-open]')){ e.preventDefault(); openModal(); }
    else if(e.target.closest('[data-rev-close]')){ e.preventDefault(); closeModal(); }
  });
  document.addEventListener('keydown', function(e){ if(e.key==='Escape' && modal.classList.contains('open')) closeModal(); });

  // star rating input
  var btns = [].slice.call(modal.querySelectorAll('.rstar-btn'));
  function paint(v){ btns.forEach(function(b){ b.classList.toggle('on', (+b.dataset.v) <= v); }); }
  btns.forEach(function(b){
    b.addEventListener('mouseenter', function(){ paint(+b.dataset.v); });
    b.addEventListener('click', function(){ if(ratingInput) ratingInput.value = b.dataset.v; paint(+b.dataset.v); modal.querySelector('.rstars-input').classList.add('chosen'); });
  });
  var starWrap = modal.querySelector('.rstars-input');
  if(starWrap) starWrap.addEventListener('mouseleave', function(){ paint(ratingInput && ratingInput.value ? +ratingInput.value : 0); });

  // submit via Shopify contact form (AJAX) so the merchant receives the review for moderation
  if(form){
    form.addEventListener('submit', function(e){
      e.preventDefault();
      if(!ratingInput.value){ modal.querySelector('.rstars-input').classList.add('error'); return; }
      var btn = form.querySelector('button[type=submit]'); if(btn){ btn.disabled = true; btn.textContent = 'Senden…'; }
      fetch('/contact', { method:'POST', body:new FormData(form), headers:{'Accept':'text/html'} })
        .then(function(){ form.hidden = true; if(done) done.hidden = false; })
        .catch(function(){ form.submit(); });
    });
  }
})();

/* PDP specs accordion — animated expand/collapse */
(function(){
  var specs = document.querySelectorAll('.pdp-specs .spec'); if(!specs.length) return;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  specs.forEach(function(d){
    var summary = d.querySelector('summary'), body = d.querySelector('.spec__body');
    if(!summary || !body) return;
    summary.addEventListener('click', function(e){
      e.preventDefault();
      if(reduce){ d.open = !d.open; return; }
      if(body.dataset.animating) return;
      var opening = !d.open;
      body.dataset.animating = '1';
      if(opening){
        d.open = true;
        var h = body.scrollHeight;
        body.style.height = '0px'; body.getBoundingClientRect(); body.style.height = h + 'px';
      } else {
        body.style.height = body.scrollHeight + 'px'; body.getBoundingClientRect(); body.style.height = '0px';
      }
      var done = false;
      function settle(){
        if(done) return; done = true;
        body.removeEventListener('transitionend', onEnd);
        if(opening){ body.style.height = 'auto'; } else { d.open = false; body.style.height = ''; }
        delete body.dataset.animating;
      }
      function onEnd(e){ if(e.propertyName === 'height') settle(); }
      body.addEventListener('transitionend', onEnd);
      setTimeout(settle, 480); // fallback so it never gets stuck if transitionend doesn't fire
    });
  });
})();

/* PDP size guide — reactive print-scale preview under the Format list.
   "Im Raum": sideboard + 170 cm person with the print hung to scale.
   "Vergleich": every format nested at a shared corner, true relative scale.
   Pure SVG, progressive enhancement; sizes are read from the .psize labels
   (dimensions parsed from .psize__name) and it reacts to the vradio change. */
(function(){
  var host = document.getElementById('psizeGuide'); if(!host) return;
  var fieldset = document.querySelector('.psize'); if(!fieldset) return;

  function parseDims(str){
    var m = String(str).match(/(\d+(?:[.,]\d+)?)\s*[×x*]\s*(\d+(?:[.,]\d+)?)/i);
    if(!m) return null;
    var w = parseFloat(m[1].replace(',','.')), h = parseFloat(m[2].replace(',','.'));
    if(!w || !h) return null;
    return { w:w, h:h };
  }

  var sizes = [];
  [].slice.call(fieldset.querySelectorAll('input[name="vradio"]')).forEach(function(r){
    var label = document.querySelector('label[for="'+r.id+'"]');
    var nameEl = label && label.querySelector('.psize__name');
    var descEl = label && label.querySelector('.psize__desc');
    var dims = nameEl && parseDims(nameEl.textContent);
    if(dims) sizes.push({ id:r.value, w:dims.w, h:dims.h, name:nameEl.textContent.trim(), desc: descEl ? descEl.textContent.trim() : '' });
  });
  if(!sizes.length){ host.style.display='none'; return; }

  var maxW=0, maxH=0;
  sizes.forEach(function(s){ if(s.w>maxW)maxW=s.w; if(s.h>maxH)maxH=s.h; });

  var cs = getComputedStyle(document.documentElement);
  function cv(n,f){ return (cs.getPropertyValue(n).trim() || f); }
  function rgba(hex,a){
    hex = hex.replace('#','');
    if(hex.length===3) hex = hex[0]+hex[0]+hex[1]+hex[1]+hex[2]+hex[2];
    var n = parseInt(hex,16);
    return 'rgba('+((n>>16)&255)+','+((n>>8)&255)+','+(n&255)+','+a+')';
  }
  var goldHex = cv('--gold','#C9A24B'), inkHex = cv('--ink','#EFEBE2');
  var col = {
    gold: goldHex,
    goldSoft: rgba(goldHex,0.35),
    goldFill: rgba(goldHex,0.08),
    hair: cv('--line','rgba(255,255,255,.12)'),
    faint: rgba(inkHex,0.16),
    faint2: rgba(inkHex,0.30),
    muted: rgba(inkHex,0.42),
    shadow: 'rgba(0,0,0,0.35)'
  };

  function rect(x,y,w,h,stroke,sw,fill){
    return '<rect x="'+x.toFixed(1)+'" y="'+y.toFixed(1)+'" width="'+w.toFixed(1)+'" height="'+h.toFixed(1)+'" fill="'+(fill||'none')+'" stroke="'+stroke+'" stroke-width="'+sw+'"/>';
  }
  function line(x1,y1,x2,y2,stroke,sw){
    return '<line x1="'+x1.toFixed(1)+'" y1="'+y1.toFixed(1)+'" x2="'+x2.toFixed(1)+'" y2="'+y2.toFixed(1)+'" stroke="'+stroke+'" stroke-width="'+sw+'"/>';
  }
  function text(x,y,t,fill,size,anchor){
    return '<text x="'+x.toFixed(1)+'" y="'+y.toFixed(1)+'" fill="'+fill+'" font-size="'+size+'" text-anchor="'+(anchor||'start')+'" letter-spacing="0.5">'+t+'</text>';
  }
  function svgOpen(viewH,ids,title,desc){
    return '<svg viewBox="0 0 360 '+viewH+'" role="img" aria-labelledby="'+ids[0]+' '+ids[1]+'" preserveAspectRatio="xMidYMax meet">'
      +'<title id="'+ids[0]+'">'+title+'</title><desc id="'+ids[1]+'">'+desc+'</desc>';
  }

  function svgRoom(a){
    var floor=292, gap=20, sbW=200, sbH=78, personH=170;
    var ppc = Math.min((floor-8-gap)/(sbH+maxH), (floor-24)/personH);
    var sbX=34, sbTop=floor-sbH*ppc, legH=18, bodyBot=floor-legH, midY=sbTop+(bodyBot-sbTop)/2, o='';
    var fw=a.w*ppc, fh=a.h*ppc, fcx=sbX+sbW/2, fbot=sbTop-gap, fx=fcx-fw/2, fy=fbot-fh;
    // sideboard — line-art console (outlined body, divider, knobs, legs)
    o += '<ellipse cx="'+(sbX+sbW/2)+'" cy="'+(floor+5)+'" rx="'+(sbW/2+4)+'" ry="6.5" fill="'+col.shadow+'"/>';
    o += rect(sbX,sbTop,sbW,bodyBot-sbTop,col.faint2,1);
    o += line(sbX,midY,sbX+sbW,midY,col.hair,0.6);
    o += '<circle cx="'+(sbX+sbW*0.32)+'" cy="'+(sbTop+(bodyBot-sbTop)*0.27).toFixed(1)+'" r="2.2" fill="none" stroke="'+col.faint2+'" stroke-width="0.6"/>';
    o += '<circle cx="'+(sbX+sbW*0.68)+'" cy="'+(sbTop+(bodyBot-sbTop)*0.27).toFixed(1)+'" r="2.2" fill="none" stroke="'+col.faint2+'" stroke-width="0.6"/>';
    o += line(sbX+10,bodyBot,sbX+10,floor,col.faint2,1)+line(sbX+50,bodyBot,sbX+50,floor,col.faint2,1)+line(sbX+sbW-50,bodyBot,sbX+sbW-50,floor,col.faint2,1)+line(sbX+sbW-10,bodyBot,sbX+sbW-10,floor,col.faint2,1);
    // decorations on the shelf — each shown only where it clears the hung print (wide/landscape prints leave no room)
    var ty=sbTop;
    if(sbX+41 <= fx){ o += '<rect x="'+(sbX+22)+'" y="'+(ty-26)+'" width="13" height="26" rx="5" fill="none" stroke="'+col.goldSoft+'" stroke-width="1"/>'; }
    if(sbX+61 <= fx){ o += rect(sbX+44,ty-15,5,15,col.faint2,0.8)+rect(sbX+50,ty-19,5,19,col.faint2,0.8); }
    if(sbX+151 >= fx+fw){ var px=sbX+172; o += line(px,ty,px,ty-30,col.faint2,1)+'<path d="M '+px+' '+(ty-30)+' q -11 -5 -15 -16 q 12 2 15 12 q 3 -10 15 -12 q -4 11 -15 16 Z" fill="none" stroke="'+col.faint2+'" stroke-width="1"/>'; }
    // person (170 cm) — silhouette + height reference
    var pcx=308, pH=personH*ppc, hr=pH*0.052, hcy=floor-pH+hr, shY=hcy+hr*1.7, shW=pH*0.072, hemW=pH*0.058, headTop=floor-pH;
    o += '<ellipse cx="'+pcx+'" cy="'+(floor+6)+'" rx="22" ry="6" fill="'+col.shadow+'"/>';
    var body='M '+(pcx-shW)+' '+shY+' C '+(pcx-shW*1.05)+' '+(shY+pH*0.13)+' '+(pcx-hemW)+' '+(floor-pH*0.10)+' '+(pcx-hemW)+' '+floor+' L '+(pcx+hemW)+' '+floor+' C '+(pcx+hemW)+' '+(floor-pH*0.10)+' '+(pcx+shW*1.05)+' '+(shY+pH*0.13)+' '+(pcx+shW)+' '+shY+' Z';
    o += '<path d="'+body+'" fill="'+col.faint+'" stroke="'+col.faint2+'" stroke-width="0.5"/>';
    o += '<circle cx="'+pcx+'" cy="'+hcy.toFixed(1)+'" r="'+hr.toFixed(1)+'" fill="'+col.faint+'" stroke="'+col.faint2+'" stroke-width="0.5"/>';
    var hx=276;
    o += line(hx,headTop,hx,floor,col.faint2,0.6);
    o += line(hx-4,headTop,hx+4,headTop,col.faint2,0.6)+line(hx-4,floor,hx+4,floor,col.faint2,0.6);
    o += text(hx,headTop-7,'170 cm',col.gold,12,'middle');
    // print to scale (geometry computed above)
    o += rect(fx,fy,fw,fh,col.gold,1.5,col.goldFill);
    if(fw>16 && fh>16) o += rect(fx+4,fy+4,fw-8,fh-8,col.goldSoft,0.5);
    return svgOpen(312,['psg-room-t','psg-room-d'],'Format im Raum','Das gewählte Format maßstabsgetreu über einem Sideboard, daneben eine 170 cm große Person als Größenreferenz.')+o+'</svg>';
  }

  function svgCompare(active){
    var bx=66, by=296, targetH=256, targetW=250;
    var ppc = Math.min(targetH/Math.max(maxH,100), targetW/maxW);
    var o = line(40,by,344,by,col.hair,0.5);
    var meterTop = by-100*ppc;
    o += line(46,by,46,meterTop,col.faint2,0.5);
    o += line(42,by,50,by,col.faint2,0.5)+line(42,meterTop,50,meterTop,col.faint2,0.5);
    o += text(40,meterTop+12,'1 m',col.muted,12);
    sizes.forEach(function(s){ if(s!==active) o += rect(bx,by-s.h*ppc,s.w*ppc,s.h*ppc,col.hair,0.5); });
    var aw=active.w*ppc, ah=active.h*ppc, ay=by-ah;
    o += rect(bx,ay,aw,ah,col.gold,1.5,col.goldFill);
    if(bx+aw+99 <= 356) o += text(bx+aw+9,ay+13,active.name,col.gold,13);
    else o += text(bx,ay-7,active.name,col.gold,13);
    return svgOpen(320,['psg-cmp-t','psg-cmp-d'],'Größenvergleich','Alle Formate maßstabsgetreu übereinandergelegt, das gewählte Format in Gold, mit 1-Meter-Referenz.')+o+'</svg>';
  }

  host.innerHTML = '<button type="button" class="psg-trigger" aria-haspopup="dialog" aria-controls="psgModal">'
    +'<i class="ti ti-ruler-2" aria-hidden="true"></i> Größenvorschau</button>';
  var trigger = host.querySelector('.psg-trigger');

  var sizesHtml = '<div class="psg__sizes" role="group" aria-label="Format wählen">';
  sizes.forEach(function(s,idx){
    var r = fieldset.querySelector('input[name="vradio"][value="'+s.id+'"]');
    sizesHtml += '<button type="button" class="psg__size" data-i="'+idx+'"'+(r && r.disabled ? ' disabled' : '')+'>'+s.name.replace(' cm','')+'</button>';
  });
  sizesHtml += '</div>';

  var modal = document.createElement('div');
  modal.className = 'psg-modal';
  modal.id = 'psgModal';
  modal.setAttribute('aria-hidden','true');
  modal.innerHTML =
    '<div class="psg-modal__backdrop" data-psg-close></div>'
    +'<div class="psg-modal__panel" role="dialog" aria-modal="true" aria-labelledby="psgTitle">'
      +'<button type="button" class="psg-modal__close" data-psg-close aria-label="Schließen"><i class="ti ti-x" aria-hidden="true"></i></button>'
      +'<h2 class="psg-modal__title" id="psgTitle">Wie groß wird dein Print?</h2>'
      +'<div class="psg__tabs" role="group" aria-label="Ansicht">'
        +'<button type="button" class="psg__tab on" data-mode="room" aria-pressed="true">Im Raum</button>'
        +'<button type="button" class="psg__tab" data-mode="compare" aria-pressed="false">Vergleich</button>'
      +'</div>'
      +'<div class="psg__stage" id="psgStage"></div>'
      +sizesHtml
      +'<div class="psg__cap" id="psgCap" aria-live="polite"></div>'
      +'<button type="button" class="btn solid block psg-modal__apply">Format übernehmen</button>'
    +'</div>';
  document.body.appendChild(modal);

  var stage = modal.querySelector('#psgStage'), cap = modal.querySelector('#psgCap');
  var sizeBtns = modal.querySelectorAll('.psg__size');
  var mode='room', cur=0, lastDesc=null, lastFocus=null;

  function pageIndex(){
    var checked = fieldset.querySelector('input[name="vradio"]:checked');
    var id = checked ? checked.value : null;
    if(id!=null){ for(var k=0;k<sizes.length;k++){ if(sizes[k].id===id) return k; } }
    return 0;
  }
  function draw(){
    var a=sizes[cur];
    stage.innerHTML = mode==='compare' ? svgCompare(a) : svgRoom(a);
    if(a.desc!==lastDesc){ lastDesc=a.desc; cap.textContent=a.desc||''; }
    sizeBtns.forEach(function(b){ var on=(+b.getAttribute('data-i'))===cur; b.classList.toggle('on',on); b.setAttribute('aria-pressed',on?'true':'false'); });
  }
  function open(){
    cur=pageIndex(); lastDesc=null; draw();
    lastFocus = document.activeElement;
    modal.classList.add('open'); modal.setAttribute('aria-hidden','false');
    document.body.style.overflow='hidden';
    var c=modal.querySelector('.psg-modal__close'); if(c) c.focus();
  }
  function close(){
    modal.classList.remove('open'); modal.setAttribute('aria-hidden','true');
    document.body.style.overflow='';
    if(lastFocus && lastFocus.focus) lastFocus.focus();
  }
  function apply(){
    var r = fieldset.querySelector('input[name="vradio"][value="'+sizes[cur].id+'"]');
    if(r && !r.disabled && !r.checked){ r.checked=true; r.dispatchEvent(new Event('change',{bubbles:true})); }
    close();
  }

  trigger.addEventListener('click', open);
  modal.addEventListener('click', function(e){ if(e.target.closest('[data-psg-close]')) close(); });
  document.addEventListener('keydown', function(e){ if(e.key==='Escape' && modal.classList.contains('open')) close(); });
  modal.querySelector('.psg-modal__apply').addEventListener('click', apply);
  modal.querySelectorAll('.psg__tab').forEach(function(btn){
    btn.addEventListener('click', function(){
      mode = btn.getAttribute('data-mode');
      modal.querySelectorAll('.psg__tab').forEach(function(b){
        var on = b===btn;
        b.classList.toggle('on', on);
        b.setAttribute('aria-pressed', on?'true':'false');
      });
      draw();
    });
  });
  sizeBtns.forEach(function(b){
    b.addEventListener('click', function(){
      if(b.disabled) return;
      cur = +b.getAttribute('data-i');
      draw();
    });
  });
})();

/* full-screen mobile menu */
(function(){
  var burger = document.getElementById('navBurger');
  var menu = document.getElementById('mobileMenu');
  if(!burger || !menu) return;
  function open(){
    menu.classList.add('open');
    menu.setAttribute('aria-hidden','false');
    burger.setAttribute('aria-expanded','true');
    document.body.style.overflow='hidden';
  }
  function close(){
    menu.classList.remove('open');
    menu.setAttribute('aria-hidden','true');
    burger.setAttribute('aria-expanded','false');
    document.body.style.overflow='';
  }
  burger.addEventListener('click', open);
  menu.addEventListener('click', function(e){
    if(e.target.closest('[data-menu-close]') || e.target.closest('a')) close();
  });
  document.addEventListener('keydown', function(e){
    if(e.key === 'Escape' && menu.classList.contains('open')) close();
  });
})();

/* Großformat-Hinweis: Tap/Klick aufs Info-Icon darf die Größe (Radio) NICHT auswählen.
   Capture-Phase + preventDefault verhindert die Label->Radio-Aktivierung; Fokus öffnet
   den Tooltip auf Touch (CSS :focus). Escape/Außenklick schließt ihn wieder. */
(function(){
  document.addEventListener('click', function(e){
    var info = e.target.closest && e.target.closest('.psize__info');
    if(!info) return;
    e.preventDefault();
    e.stopPropagation();
    if(document.activeElement === info){ info.blur(); } else { info.focus(); }
  }, true);
  document.addEventListener('keydown', function(e){
    if(e.key === 'Escape' && document.activeElement &&
       document.activeElement.classList.contains('psize__info')){
      document.activeElement.blur();
    }
  });
})();
